module.exports = __webpack_public_path__ + "static/img/outpatientb.a2364e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outpatientb.png
// module id = KdCV
// module chunks = 1